import { Illustration, Text } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { Stack } from "@mui/material";
import { PullToRefresh } from "@src/appV2/lib/PullToRefresh/PullToRefresh";

import { PageWrapper } from "../../components/PageWrapper";
import { StickyScrollPageHeader } from "../../components/StickyScrollPageHeader";

interface ErrorPageProps {
  title: string;
  description?: string;
  onRefresh?: () => Promise<any>;
}

export function ClipboardScoreError(props: ErrorPageProps) {
  const { title, description, onRefresh } = props;

  return (
    <PageWrapper variant="tertiary">
      {isDefined(onRefresh) && <PullToRefresh onRefresh={onRefresh} />}
      <StickyScrollPageHeader title={title} headerVariant="tertiary" />

      <Stack
        direction="column"
        spacing={7}
        sx={{
          padding: 5,
          flex: 1,
          textAlign: "center",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {isDefined(description) && <Text>{description}</Text>}

        <Illustration type="error" />

        <Text sx={{ mb: 2 }}>
          Please pull down to refresh. If you keep having trouble, please reach out to our Support
          team.
        </Text>
      </Stack>
    </PageWrapper>
  );
}
